(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory();
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else{
        root.console=factory();
    }
})(this,function(){
    'use strict'
    var undef = 'undefined';
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;

	var stubApi = 'log,dir,dirxml,info,warn,debug,error,assert,trace,time,timeEnd'.split(',');
	var _noop=function(){};
	var UNDEFINED = "undefined";
	var konsole;

		//Build a stand-in console if missing
	if(typeof root!==UNDEFINED){
		if(!root.console){
	        root.console={
	        	isNative : false
	        };
	    }
	    stubApi.forEach(function(meth){
	        root.console[meth]=root.console[meth]||root.console.log||_noop;
	    });
	 
	}
	
   konsole = console || root && root.console || {};
   konsole.trueConsole = !!konsole.group && !!konsole.log.apply && !konsole.msIsIndependentlyComposed;

	return konsole;
});